/**
 * "How refunds resolve" (docs/05-admin/17 §3 item 1): the M1–M12 matrix of backend doc 28 §5.6,
 * read-only, behind a button on the refunds queue and the cancellation-policy editor.
 *
 * **Built from the spec, not a design** (owner ruling 2026-10-26). The rows live in
 * `refundMatrix.json`, and `refundMatrix.test.ts` parses the doc's table and fails if the two
 * differ, so the panel cannot drift from the matrix the backend is built and tested against.
 * The amounts are the doc's worked example (the canonical ₹3,399 booking under the launch
 * policy), and the panel says so: a booking's own figures are on its refund preview.
 */
import { useState } from 'react';
import { Button, Note } from '../components/primitives';
import { DataTable } from '../components/data';
import { Modal } from '../components/feedback';
import MATRIX from './refundMatrix.json';

export interface MatrixRow {
  id: string;
  who: string;
  when: string;
  devotee_receives: string;
  pandit_payable: string;
  platform_keeps: string;
  booking_ends: string;
}

export const REFUND_MATRIX: readonly MatrixRow[] = MATRIX;

export function RefundMatrixButton() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button size="sm" variant="secondary" icon="scale" onClick={() => setOpen(true)}>
        How refunds resolve
      </Button>
      <Modal open={open} title="How refunds resolve" width={1080} onClose={() => setOpen(false)}>
        <Note>
          Who cancelled, and when, decides the money. Amounts are the worked example in backend doc
          28 §5.6: a ₹3,399 booking under Standard home puja v1. A booking&apos;s own figures are on
          its refund preview.
        </Note>
        <DataTable
          density="compact"
          columns={[
            { key: 'id', label: '#', mono: true },
            { key: 'who', label: 'Who' },
            { key: 'when', label: 'When' },
            { key: 'devotee_receives', label: 'Devotee receives' },
            { key: 'pandit_payable', label: 'Pandit payable' },
            { key: 'platform_keeps', label: 'Platform keeps' },
            { key: 'booking_ends', label: 'Booking ends', mono: true },
          ]}
          rows={REFUND_MATRIX.map((r) => ({ ...r }))}
        />
      </Modal>
    </>
  );
}
